module.exports = __webpack_public_path__ + "media/images/cse-footer-2-94e00cff629bfa031bcca242547d38a8.png";